import script from "./TableOverlayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TableOverlayModal.vue?vue&type=script&setup=true&lang=js"

import "./TableOverlayModal.vue?vue&type=style&index=0&id=2e392820&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e392820"]])

export default __exports__